import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { Card, Input, List, Space, Button, Empty, Dropdown, Menu, } from "antd";
import { PlusOutlined, ReloadOutlined, EllipsisOutlined, } from "@ant-design/icons";
const { Search } = Input;
/**
 * 通用列表面板组件
 */
const GenericPanelList = ({ title = "数据列表", listData = [], loading = false, buttons = [], onSelect, onAddClick, onRefresh, height = "100%", showSearch = true, selectedId, menuItems = [], // 默认为空数组
onMenuClick, }) => {
    // 状态定义
    const [searchValue, setSearchValue] = useState("");
    const [filteredListData, setFilteredListData] = useState(listData);
    // 当原始列表数据变化时，更新过滤后的列表数据
    useEffect(() => {
        if (searchValue) {
            filterList(searchValue);
        }
        else {
            setFilteredListData(listData);
        }
    }, [listData]);
    // 处理搜索
    const handleSearch = (value) => {
        setSearchValue(value);
        if (value) {
            filterList(value);
        }
        else {
            setFilteredListData(listData);
        }
    };
    // 过滤列表数据
    const filterList = (value) => {
        const filtered = listData.filter((item) => item.leftContent.toLowerCase().includes(value.toLowerCase()));
        setFilteredListData(filtered);
    };
    // 构建默认按钮
    const defaultButtons = [];
    // 添加刷新按钮
    if (onRefresh) {
        defaultButtons.push(_jsx(Button, { type: "link", icon: _jsx(ReloadOutlined, {}), onClick: onRefresh, style: {
                fontSize: "14px",
                padding: "0 8px",
            }, children: "\u5237\u65B0" }, "refresh"));
    }
    // 添加新增按钮
    if (onAddClick) {
        defaultButtons.push(_jsx(Button, { type: "link", icon: _jsx(PlusOutlined, {}), onClick: onAddClick, style: {
                fontSize: "14px",
                padding: "0 8px",
            }, children: "\u6DFB\u52A0" }, "add"));
    }
    // 合并默认按钮和自定义按钮
    const allButtons = [...defaultButtons, ...buttons];
    // 从标签或其他React元素中提取数字
    const extractNumberFromContent = (content) => {
        // 如果已经是数字或字符串，直接返回
        if (typeof content === "number")
            return content.toString();
        if (typeof content === "string")
            return content;
        // 处理React元素
        if (React.isValidElement(content)) {
            // 如果是Tag组件，尝试从children中提取
            const children = content.props.children;
            if (children) {
                // 如果children是字符串，提取数字部分
                if (typeof children === "string") {
                    const match = children.match(/(\d+)/);
                    return match ? match[1] : "0";
                }
                // 如果children是数字
                if (typeof children === "number") {
                    return children.toString();
                }
            }
        }
        // 默认返回0
        return "0";
    };
    // 渲染菜单图标及下拉菜单
    const renderItemMenu = (item) => {
        const menu = (_jsx(Menu, { onClick: ({ key }) => onMenuClick && onMenuClick(item, key), children: menuItems.map((menuItem) => (_jsx(Menu.Item, { children: menuItem.label }, menuItem.key))) }));
        return (_jsx(Dropdown, { overlay: menu, trigger: ["click"], children: _jsx(Button, { type: "text", icon: _jsx(EllipsisOutlined, {}), size: "small", onClick: (e) => e.stopPropagation(), style: {
                    marginLeft: "auto",
                    padding: "0 5px",
                    color: "#bfbfbf",
                }, className: "list-item-menu-button" }) }));
    };
    return (_jsxs(Card, { title: title, extra: _jsx(Space, { children: allButtons.map((button, index) => React.cloneElement(button, { key: index })) }), className: "list-panel", loading: loading, style: {
            height: typeof height === "number" ? `${height}px` : height,
        }, styles: {
            body: {
                padding: showSearch ? "0 16px" : "0 16px",
                display: "flex",
                flexDirection: "column",
                height: "100%",
                overflow: "hidden",
                paddingTop: 16,
                rowGap: 16, // 使用 gap 控制子元素之间的垂直间距，避免子元素 margin 影响剩余高度
            },
        }, children: [showSearch && (_jsx(Search, { placeholder: "\u641C\u7D22...", allowClear: true, onChange: (e) => handleSearch(e.target.value), style: {} })), _jsx("div", { style: {
                    flex: 1,
                    minHeight: 0,
                    overflow: "auto",
                }, children: filteredListData.length > 0 ? (_jsx(List, { className: "position-list", dataSource: filteredListData, renderItem: (item) => (_jsx(List.Item, { onClick: () => onSelect && onSelect(item), style: {
                            cursor: onSelect ? "pointer" : "default",
                            backgroundColor: selectedId === item.id ? "#f0f7ff" : "transparent",
                            padding: "8px",
                            borderRadius: "4px",
                            transition: "background-color 0.3s",
                        }, className: "list-item", children: _jsxs("div", { style: {
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                alignItems: "center",
                            }, children: [_jsxs("div", { style: {
                                        display: "flex",
                                        alignItems: "center",
                                        fontWeight: selectedId === item.id ? 500 : 400,
                                    }, children: [_jsx("span", { style: { marginRight: "8px" }, children: item.leftContent }), item.rightContent && (_jsx("div", { style: {
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                backgroundColor: "rgba(24, 144, 255, 0.7)",
                                                color: "white",
                                                borderRadius: "50%",
                                                width: "16px",
                                                height: "16px",
                                                fontSize: "10px",
                                                fontWeight: "normal",
                                                lineHeight: "20px",
                                                textAlign: "center",
                                            }, children: extractNumberFromContent(item.rightContent) }))] }), onMenuClick && menuItems.length > 0 && renderItemMenu(item)] }) }, item.id)) })) : (_jsx(Empty, { description: "\u6682\u65E0\u6570\u636E" })) })] }));
};
export default GenericPanelList;
